export default __webpack_public_path__ + "static/media/a5.75bc8784.png";